'use client';

import { useTheme } from 'next-themes';
import { DemoGridComponent } from './demo-grid-component';

export function DemoGridWrapper() {
  const { resolvedTheme } = useTheme();

  return <DemoGridComponent theme={resolvedTheme} />;
}